export default __webpack_public_path__ + "static/media/flexpay.4dfdb94e.png";